import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GroupInfo, GroupPrivacyLevel } from '@app/groups/group-api';
import { SearchSubmitMethod } from '@app/search/services/search-tracker.service';
import { SimpleItemViewModel } from '@app/shared/models/core-view.model';
import { TranslateService } from '@ngx-translate/core';

export interface GroupsMatchViewModel extends SimpleItemViewModel<GroupInfo> {}
@Component({
  selector: 'dgx-search-groups',
  templateUrl: './search-groups.component.html',
  styleUrls: ['./search-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchGroupsComponent {
  @Input() public items: GroupsMatchViewModel[];
  @Input() public isLoading: boolean;
  @Input() public totalNumItems: number;
  @Input() public searchTerm: string;

  public i18n: { [key: string]: string } = this.translateService.instant([
    'LearningSearch_Groups',
    'LearningSearch_OpenGroup',
    'LearningSearch_ClosedGroup',
  ]);

  constructor(private translateService: TranslateService) {}

  public get linkData() {
    return {
      route: '/learning/groups',
      searchTerm: this.searchTerm,
      collectionLink: SearchSubmitMethod.moreGroups,
    };
  }

  public get showNoResults(): boolean {
    return this.totalNumItems === 0 && !this.isLoading;
  }

  public get showError(): boolean {
    return !this.items && !this.isLoading;
  }

  public getA11yText(privacyLevel: GroupPrivacyLevel): string {
    return privacyLevel === GroupPrivacyLevel.Open
      ? this.i18n.LearningSearch_OpenGroup
      : this.i18n.LearningSearch_ClosedGroup;
  }

  public getIconType(privacyLevel: GroupPrivacyLevel): string {
    return privacyLevel === GroupPrivacyLevel.Open
      ? 'person-triple'
      : 'lock-closed';
  }

  public trackByFn(
    index: number,
    item: SimpleItemViewModel<GroupInfo>
  ): number {
    return item.model.groupId;
  }
}
